const key_salt = process.env.REACT_APP_KEY_CHIPER;

const jsonEncrypt = (salt) => {
  const saltChars = [...salt].map(c => c.charCodeAt(0));

  const applySaltToChar = code => {
    return saltChars.reduce((acc, b) => acc ^ b, code);
  };

  const toHex4 = n => n.toString(16).padStart(4, '0');

  return text => {
    return [...text]
      .map(c => c.codePointAt(0))
      .map(applySaltToChar)
      .map(toHex4)
      .join('');
  };
};

const jsonDecrypt = (salt) => {
  const saltChars = [...salt].map(c => c.charCodeAt(0));

  const applySaltToChar = code => {
    return saltChars.reduce((acc, b) => acc ^ b, code);
  };

  return encoded => {
    if (encoded.length % 4 !== 0) return "";

    let result = "";
    for (let i = 0; i < encoded.length; i += 4) {
      const hexCode = encoded.slice(i, i + 4);
      const val = parseInt(hexCode, 16);

      if (isNaN(val)) continue;

      const code = applySaltToChar(val);
      result += String.fromCodePoint(code);
    }

    return result;
  };
};

export const myJsonEncrypt = jsonEncrypt(key_salt);
export const myJsonDecrypt = jsonDecrypt(key_salt);